<script setup>
import { useUserStore } from '@/stores/user'
import { storeToRefs } from 'pinia'
import { computed, watch } from 'vue'
import { useRouter } from 'vue-router'

const userStore = useUserStore()
const { user, profileCompletionPercentage } = storeToRefs(userStore)
const router = useRouter()

const completionPercentages = new Map([
  [0, 75],
  [1, 85],
  [2, 95],
  [3, 100]
])

const completionPercentage = computed(() => {
  const about = user.value?.about
  const interests = user.value?.interests
  const photos = user.value?.photos?.items.length

  const array = [about, interests, photos]
  const count = array.filter(value => !!value).length

  return completionPercentages.get(count)
})

watch(completionPercentage, (value) => {
  if (value) {
    profileCompletionPercentage.value = value
  }
}, { immediate: true })

function goTo () {
  const about = user.value?.about
  const interests = user.value?.interests
  const photos = user.value?.photos?.items.length

  if (!about || !interests) {
    router.push('/details?r=me')
  }
  else if (!photos) {
    router.push('/photo-upload?r=me')
  }
  else {
    router.push('/')
  }
}

function highlightNumbers (str) {
  return str.replace(/(\d+)%|%(\d+)|(\d+)/g, (match, p1, p2, p3) => {
    if (p1) return `<b>${p1}</b>%`   // число + %
    if (p2) return `%<b>${p2}</b>`   // % + число
    if (p3) return `<b>${p3}</b>`    // просто число
  })
}
</script>

<template>
  <a
    v-if="completionPercentage !== 100"
    class="flex justify-between py-3.5 px-4 bg-gradient-to-r from-[#fae28b] to-[#8efaba] rounded-lg relative cursor-pointer"
    @click="goTo">
    <div class="flex items-center gap-2.5 relative z-10">
      <InlineSvg
        class="w-5 h-5 text-gray-500 shrink-0"
        :src="require('@/assets/fontawesome/regular/loader.svg')"/>

      <div class="flex-1" v-html="highlightNumbers($t('user.me.your_profile_is_complete', { percentage: completionPercentage }))"/>
    </div>

    <InlineSvg
      class="relative z-10 w-3 text-gray-400"
      :src="require('@/assets/fontawesome/regular/chevron-right.svg')"/>

    <div
      :style="{ width: `${100 - completionPercentage}%` }"
      class="bg-gray-100 rounded-r-lg h-full absolute right-0 top-0 -z-0"/>
  </a>
</template>